import I18n from 'i18n-js'

export type Alignment = 'tl' | 'tr' | 'bl' | 'br'

export const directionSensitivePopupAlign = (
  points: Alignment[],
  offset: number[],
  direction = I18n.t('direction')
) => {
  return direction === 'rtl'
    ? {
        points: points.map(x => flipAlignment(x)),
        offset: [-offset[0], offset[1]]
      }
    : {
        points,
        offset
      }
}

export const flipAlignment = (point: Alignment) =>
  ({
    tr: 'tl',
    tl: 'tr',
    bl: 'br',
    br: 'bl'
  }[point])

// For more information, see: https://www.iamcal.com/understanding-bidirectional-text/
export function forceLtr(text: string): string {
  const direction = I18n.t('direction')
  return direction === 'rtl' ? LRE + text + PDF : text
}

const LRE = '\u202A' // Left-to-right embedding
const PDF = '\u202C' // Pop directional formatting
